import React from "react";
import "./styles.scss";
import EarthQuake from "../EarthQuake";
import EarthQuakeFeed from "../EarthQuakeFeed";

const EarthQuakePage = () => {
  return (
    <div className="EarthQuakePage">
      <EarthQuake />
      <EarthQuakeFeed />
    </div>
  );
};

export default EarthQuakePage;
